import crypto from 'crypto';

const SECRET_KEY = process.env.REACT_APP_OLD_KEY;
const IV = process.env.REACT_APP_OLD_VI;

const nameVal = process.env.REACT_APP_NEW_KEY;
const opVal = process.env.REACT_APP_NEW_VI;

const namingVal = 'proefficoindiapollscustomertrust';
const opingVal = '2513150110081000';

export function encryptData(data) {
    const cipher = crypto.createCipheriv('aes-256-cbc', SECRET_KEY, IV);
    let encrypted = cipher.update(JSON.stringify(data), 'utf8', 'base64');
    encrypted += cipher.final('base64');
    return encrypted;
}

export function decryptData(encryptedData) {
    const decipher = crypto.createDecipheriv('aes-256-cbc', SECRET_KEY, IV);
    let decrypted = decipher.update(encryptedData, 'base64', 'utf8');
    decrypted += decipher.final('utf8');
    return JSON.parse(decrypted);
}

export function decryptTkData(paramData) {
    const getDta = crypto.createDecipheriv('aes-256-cbc', namingVal, opingVal);
    let decDta = getDta.update(paramData, 'base64', 'utf8');
    decDta += getDta.final('utf8');
    return JSON.parse(decDta);
}

export function myIpData(data) {
    const ipVal = crypto.createCipheriv('aes-256-cbc', nameVal, opVal);
    let myOpVal = ipVal.update(JSON.stringify(data), 'utf8', 'base64');
    myOpVal += ipVal.final('base64');
    return myOpVal;
}

export function myOpData(data) {
    const ipVal = crypto.createDecipheriv('aes-256-cbc', nameVal, opVal);
    let myOpVal = ipVal.update(data, 'base64', 'utf8');
    myOpVal += ipVal.final('utf8');
    return JSON.parse(myOpVal);
}